import { useEffect } from 'react'

let dataLayer

if (typeof window !== `undefined`) {
  dataLayer = window.dataLayer
}

export const usePageViewTracking = () => {
  useEffect(() => {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'pageView',
        location: window.location.pathname,
      })
    }
  }, [])
}
